import React from 'react'
import { observer } from 'mobx-react'
import ProgressSpinner from 'components/ProgressSpinner'
import RadialProgress from 'components/RadialProgress'
import Icon from 'components/Icon'
import { FlexContainer, FlexItem } from 'components/Flex'
import './styles.sass'

const BrokerSyncingStatus = ({ provider }) => (
  <FlexContainer className="syncing" direction="column">
    <FlexItem className="has-text-centered">
      <h4 className="title is-5 is-semibold">
        {provider.syncProgress === 100
          ? (
            provider.account.status === 'postponed'
              ? 'Almost done!'
              : 'Awesome!'
          )
          : 'Syncing your account, please wait'
        }
      </h4>
      <div className="content">
        {provider.syncProgress === 100
          ? (
            provider.account.status === 'postponed'
              ? <p>Brokerage is unavailable at the moment, we will try again at the end of the day.</p>
              : <p>Your account has been synced!</p>
          )
          : <p>This may take a minute, hold tight!</p>
        }
      </div>
    </FlexItem>
    <FlexItem className="has-spacing-top">
      {provider.syncProgress === 0
        ? (
          <ProgressSpinner
            size={48}
            color="#70c79a"
          />
        )
        : (
          provider.syncProgress === 100
            ? (
              <div className="animated zoomIn">
                {provider.account.status === 'postponed'
                  ? <Icon large material name="check" color="#FFB300" />
                  : <Icon large material name="check" color="#70c79a" />
                }
              </div>
            )
            : (
              <RadialProgress
                progress={provider.syncProgress}
              />
            )
        )
      }
    </FlexItem>
  </FlexContainer>
)

export default observer(BrokerSyncingStatus)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/BrokerSyncingStatus/index.jsx